import { render, staticRenderFns } from "./SetApprovers_Leave.vue?vue&type=template&id=2a93b564&scoped=true"
import script from "./SetApprovers_Leave.vue?vue&type=script&lang=js"
export * from "./SetApprovers_Leave.vue?vue&type=script&lang=js"
import style0 from "./SetApprovers_Leave.vue?vue&type=style&index=0&id=2a93b564&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a93b564",
  null
  
)

export default component.exports